/**
 * MODE — <mode-countdown data-mode="cycle|daily|date" data-end="AAAA-MM-DDTHH:MM" data-tz="-0300" data-cycle-hours="4">
 * Contagem regressiva em chips para a announcement bar. Sem dependências e sem storage:
 * o valor é sempre derivado do relógio, então é idêntico em qualquer refresh, aba ou dispositivo.
 *
 * - cycle: termina no próximo múltiplo de N horas desde a época Unix (UTC) e recomeça sozinho.
 * - daily: até a próxima meia-noite local do visitante e recomeça.
 * - date:  até uma data fixa no fuso da loja (data-tz); mostra dias quando falta > 24 h;
 *          ao expirar esconde o timer inteiro (.announcement-bar__timer).
 */
class ModeCountdown extends HTMLElement {
  connectedCallback() {
    this.mode = this.dataset.mode || 'cycle';
    this.cycleMs = Math.max(1, Number(this.dataset.cycleHours) || 4) * 3600 * 1000;
    this.parts = {};
    for (const part of ['days', 'hours', 'minutes', 'seconds']) {
      this.parts[part] = this.querySelector(`[data-part="${part}"]`);
    }
    this.daysUnit = this.querySelector('[data-unit="days"]');
    this.end = this.computeEnd();
    if (!this.end || Number.isNaN(this.end)) {
      this.hideAll();
      return;
    }
    this.tick();
    this.timer = setInterval(() => this.tick(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.timer);
  }

  computeEnd() {
    const now = Date.now();
    if (this.mode === 'cycle') return Math.ceil((now + 1) / this.cycleMs) * this.cycleMs;
    if (this.mode === 'daily') {
      const d = new Date();
      d.setHours(24, 0, 0, 0);
      return d.getTime();
    }
    // date: "AAAA-MM-DDTHH:MM" + offset da loja ("-0300" → "-03:00"); sem offset o navegador usaria o fuso local.
    const raw = (this.dataset.end || '').trim();
    if (!raw) return NaN;
    const tz = (this.dataset.tz || '').replace(/^([+-]\d{2})(\d{2})$/, '$1:$2');
    const hasOffset = /(Z|[+-]\d{2}:?\d{2})$/.test(raw);
    const iso = raw.length === 16 ? `${raw}:00` : raw;
    return new Date(hasOffset ? iso : iso + tz).getTime();
  }

  hideAll() {
    clearInterval(this.timer);
    const wrapper = this.closest('.announcement-bar__timer');
    (wrapper || this).hidden = true;
  }

  tick() {
    let diff = Math.floor((this.end - Date.now()) / 1000);
    if (diff <= 0) {
      if (this.mode === 'date') {
        this.hideAll();
        return;
      }
      this.end = this.computeEnd();
      diff = Math.floor((this.end - Date.now()) / 1000);
    }
    const days = Math.floor(diff / 86400);
    const hours = Math.floor((diff % 86400) / 3600);
    const minutes = Math.floor((diff % 3600) / 60);
    const seconds = diff % 60;
    const pad = (n) => String(n).padStart(2, '0');
    const showDays = this.mode === 'date' && days > 0;
    if (this.daysUnit) this.daysUnit.hidden = !showDays;
    this.setPart('days', pad(days));
    this.setPart('hours', pad(showDays ? hours : hours + days * 24));
    this.setPart('minutes', pad(minutes));
    this.setPart('seconds', pad(seconds));
  }

  setPart(part, value) {
    const el = this.parts[part];
    if (el && el.textContent !== value) el.textContent = value;
  }
}

if (!customElements.get('mode-countdown')) customElements.define('mode-countdown', ModeCountdown);
